/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdatePalReauthDocumentSelection200ResponseData } from './UpdatePalReauthDocumentSelection200ResponseData';
import {
    UpdatePalReauthDocumentSelection200ResponseDataFromJSON,
    UpdatePalReauthDocumentSelection200ResponseDataFromJSONTyped,
    UpdatePalReauthDocumentSelection200ResponseDataToJSON,
    UpdatePalReauthDocumentSelection200ResponseDataToJSONTyped,
} from './UpdatePalReauthDocumentSelection200ResponseData';

/**
 * 
 * @export
 * @interface UpdatePalReauthDocumentSelection200Response
 */
export interface UpdatePalReauthDocumentSelection200Response {
    /**
     * 
     */
    data?: UpdatePalReauthDocumentSelection200ResponseData;
}

/**
 * Check if a given object implements the UpdatePalReauthDocumentSelection200Response interface.
 */
export function instanceOfUpdatePalReauthDocumentSelection200Response(value: object): value is UpdatePalReauthDocumentSelection200Response {
    return true;
}

export function UpdatePalReauthDocumentSelection200ResponseFromJSON(json: any): UpdatePalReauthDocumentSelection200Response {
    return UpdatePalReauthDocumentSelection200ResponseFromJSONTyped(json, false);
}

export function UpdatePalReauthDocumentSelection200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePalReauthDocumentSelection200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : UpdatePalReauthDocumentSelection200ResponseDataFromJSON(json['data']),
    };
}

export function UpdatePalReauthDocumentSelection200ResponseToJSON(json: any): UpdatePalReauthDocumentSelection200Response {
    return UpdatePalReauthDocumentSelection200ResponseToJSONTyped(json, false);
}

export function UpdatePalReauthDocumentSelection200ResponseToJSONTyped(value?: UpdatePalReauthDocumentSelection200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': UpdatePalReauthDocumentSelection200ResponseDataToJSON(value['data']),
    };
}

